/* @flow */
import * as React from 'react';

const Tools = props => (
  <svg
    width={126}
    height={94}
    viewBox="0 0 126 94"
    strokeWidth={3}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="#1C1F34"
    {...props}>
    <path stroke="#DEDEDE" d="M28.065,28.451 L35.021,21.451" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M45.136,68.545 C44.346,68.001 43.266,68.2 42.721,68.99 L37.977,75.875 C37.434,76.664 37.633,77.745 38.422,78.289 C40.935,80.022 43.617,80.317 43.617,80.317 L57.974,90.21 C60.644,92.049 62.587,91.691 64.425,89.022 C66.264,86.353 65.907,84.41 63.239,82.57 L48.88,72.677 C48.88,72.677 47.522,70.188 45.136,68.545"
    />
    <path d="M45.136,68.545 C44.346,68.001 43.266,68.2 42.721,68.99 L37.977,75.875 C37.434,76.664 37.633,77.745 38.422,78.289 C40.935,80.022 43.617,80.317 43.617,80.317 L57.974,90.21 C60.644,92.049 62.587,91.691 64.425,89.022 C66.264,86.353 65.907,84.41 63.239,82.57 L48.88,72.677 C48.88,72.677 47.522,70.188 45.136,68.545 Z" />
    <polygon points="16.217 53.605 14.247 56.464 18.766 62.103 25.352 62.099 40.35 72.432 25.352 62.099 22.966 55.912" />
    <path d="M72.193,1.703 C71.007,1.802 70.567,3.316 71.522,4.026 L78.895,9.5 C78.895,9.5 81.749,12.469 76.468,19.39 C73.096,23.808 70.46,27.43 68.994,29.472 C68.35,30.367 68.73,31.619 69.76,32.013 C74.427,33.793 85.818,38.786 90.837,46.722 L112.496,80.136 C114.413,83.167 118.424,84.07 121.455,82.153 C124.486,80.236 125.389,76.225 123.473,73.195 L99.46,36.06 C99.46,36.06 96.715,31.329 95.675,25.91 C94.635,20.49 95.745,13.494 92.363,8.145 C89.265,3.247 83.678,0.742 72.193,1.703 Z" />
    <path d="M69.3,29.046 C69.3,29.046 61.069,19.579 64.566,11.252 L76.468,19.39" />
    <polygon points="89.459 21.305 82.107 32.326 76.489 28.683 83.841 17.663" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M119.474,77.003 C119.659,76.183 119.144,75.37 118.324,75.185 C117.505,75 116.691,75.515 116.506,76.335 C116.322,77.154 116.836,77.968 117.656,78.153 C118.475,78.337 119.289,77.823 119.474,77.003"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M97.862,80.074 C96.165,77.458 92.564,76.922 80.838,65.196 C72.105,56.463 69.743,52.722 63.602,46.582 C61.62,44.598 59.233,42.502 56.73,40.387 L47.468,50.699 C49.417,52.995 51.347,55.172 53.179,57.005 C59.321,63.145 63.062,65.507 71.794,74.24 C83.519,85.966 84.056,89.568 86.672,91.263 C89.287,92.959 94.403,87.805 94.403,87.805 C94.403,87.805 99.558,82.69 97.862,80.074"
    />
    <path d="M26.955,26.488 L28.948,30.013 L34.312,35.378 C39.826,40.891 47.04,50.864 53.18,57.005 C59.32,63.145 63.061,65.507 71.794,74.24 C83.52,85.965 84.057,89.568 86.672,91.263 C89.288,92.959 94.403,87.805 94.403,87.805 C94.403,87.805 99.558,82.69 97.862,80.074 C96.166,77.458 92.564,76.922 80.838,65.196 C72.105,56.463 69.743,52.722 63.603,46.582 C57.463,40.441 47.49,33.227 41.976,27.714 C36.463,22.201 36.612,22.349 36.612,22.349 L33.086,20.357" />
    <path d="M19,38.162 L14.439,42.723 L1.5,29.784 L6.061,25.223 C6.837,24.448 8.094,24.448 8.869,25.223 L19,35.354 C19.775,36.129 19.775,37.387 19,38.162 Z" />
    <path d="M9.975,25.369 C9.975,25.369 11.252,25.536 12.695,24.092 C14.139,22.649 13.362,19.651 16.082,16.93 C18.802,14.21 25.742,7.27 25.742,7.27 C25.742,7.27 40.066,-7.053 56.554,9.435 C56.554,9.435 49.282,7.048 43.674,8.547 C38.067,10.046 38.122,11.212 37.623,13.71 C37.123,16.209 36.679,16.764 35.569,17.874 C34.458,18.984 25.631,27.812 25.631,27.812 C25.631,27.812 23.854,29.588 21.967,30.255 C20.079,30.921 18.563,32.992 19.543,35.898" />
    <path strokeWidth={1.5} d="M47.468,50.699 L53.189,44.329" />
    <path strokeWidth={1.5} d="M82.974,18.842 L86.026,26.331" />
    <path strokeWidth={1.5} d="M79.923,23.472 L82.975,30.961" />
  </svg>
);

export default Tools;



// WEBPACK FOOTER //
// ./src/assets/images/icons/tools.js